import { simpleSet } from '@r/reducers/utils';

const setCalculationModeAdminSettingsPullsValue = simpleSet as
  redux.reducers.calculationMode.adminSettings.projectSettings.materials.pulls.value;

export const value = setCalculationModeAdminSettingsPullsValue(
  'SET_CALCULATION_MODE_ADMIN_SETTINGS_PULLS_VALUE',
  { value: '', label: '' }
);
